import {
  Effort,
  EffortType,
  Exercise,
  Mode,
  MotorPattern,
  MuscleGroup,
  PrecompiledProgression,
  Rec,
  RepScheme,
  RepSchemeType,
  Tecnica,
  TimeUnderTension,
  Variant,
} from "../types/Entities";
import { PagedResults } from "../types/generics";
import { getEndpoint } from "../utils/stringUtil";
import client from "./axios";

const entitiesUrl = `${getEndpoint()}api/entities`;
const newEntitiesUrl = `${getEndpoint()}api/v2/entities`;

export const Entities = {
  createMotorPattern: (body: MotorPattern) =>
    client.post(`${entitiesUrl}/motor-pattern/create`, body),
  updateMotorPattern: (id: number, body: MotorPattern) =>
    client.put(`${entitiesUrl}/motor-pattern/${id}`, body),
  getMotorPatternsPaginated: (params?: URLSearchParams) =>
    client.get<PagedResults<MotorPattern> | { list: MotorPattern[] }>(
      `${newEntitiesUrl}/motor-pattern/get-paginated`,
      { params }
    ),
  getMotorPatterns: (params?: URLSearchParams) =>
    client.get<{ list: MotorPattern[] }>(`${entitiesUrl}/motor-pattern/get`, {
      params,
    }),
  deleteMotorPattern: (id: number) =>
    client.delete(`${entitiesUrl}/motor-pattern/${id}`),
  //Gruppi Muscolari
  createMuscleGroup: (body: MuscleGroup) =>
    client.post(`${entitiesUrl}/muscle-group/create`, body),
  updateMuscleGroup: (id: number, body: MuscleGroup) =>
    client.put(`${entitiesUrl}/muscle-group/${id}`, body),
  getMuscleGroupsPaginated: (params?: URLSearchParams) =>
    client.get<PagedResults<MuscleGroup> | { list: MuscleGroup[] }>(
      `${newEntitiesUrl}/muscle-group/get-paginated`,
      { params }
    ),
  getMuscleGroups: (params?: URLSearchParams) =>
    client.get<{ list: MuscleGroup[] }>(`${entitiesUrl}/muscle-group/get`, {
      params,
    }),
  deleteMuscleGroup: (id: number) =>
    client.delete(`${entitiesUrl}/muscle-group/${id}`),
  //Esercizi
  createExercise: (body: FormData) =>
    client.post(`${entitiesUrl}/exercise/create`, body),
  updateExercise: (id: number, body: FormData) =>
    client.put(`${entitiesUrl}/exercise/${id}`, body),
  getExercisesPaginated: (params?: URLSearchParams) =>
    client.get<PagedResults<Exercise> | { list: Exercise[] }>(
      `${newEntitiesUrl}/exercise/get-paginated`,
      { params }
    ),
  getExercises: (params?: URLSearchParams) =>
    client.get<{ list: Exercise[] }>(`${entitiesUrl}/exercise/get`, { params }),
  deleteExercise: (id: number) =>
    client.delete(`${entitiesUrl}/exercise/${id}`),
  //Varianti
  createVariant: (body: Variant) =>
    client.post(`${entitiesUrl}/variant/create`, body),
  updateVariant: (id: number, body: Variant) =>
    client.put(`${entitiesUrl}/variant/${id}`, body),
  getPaginatedVariants: (params?: URLSearchParams) =>
    client.get<PagedResults<Variant> | { list: Variant[] }>(
      `${newEntitiesUrl}/variant/get-paginated`,
      { params }
    ),
  getVariants: (params?: URLSearchParams) =>
    client.get<{ list: Variant[] }>(`${entitiesUrl}/variant/get`, { params }),
  deleteVariant: (id: number) => client.delete(`${entitiesUrl}/variant/${id}`),
  // Tecniche
  createTecnica: (body: Tecnica) =>
    client.post(`${entitiesUrl}/tecnica/create`, body),

  updateTecnica: (id: number, body: Tecnica) =>
    client.put(`${entitiesUrl}/tecnica/${id}`, body),

  getPaginatedTecniche: (params?: URLSearchParams) =>
    client.get<PagedResults<Tecnica> | { list: Tecnica[] }>(
      `${newEntitiesUrl}/tecnica/get-paginated`,
      { params }
    ),

  deleteTecnica: (id: number) => client.delete(`${entitiesUrl}/tecnica/${id}`),

  // Modes
  getModes: (params?: URLSearchParams) =>
    client.get<{ list: Mode[] }>(`${entitiesUrl}/mode/get`, { params }),

  getPaginatedModes: (params?: URLSearchParams) =>
    client.get<PagedResults<Mode> | { list: Mode[] }>(
      `${newEntitiesUrl}/mode/get-paginated`,
      { params }
    ),

  createMode: (body: Mode) =>
    client.post(`${entitiesUrl}/mode/create`, body),

  updateMode: (id: number, body: Mode) =>
    client.put(`${entitiesUrl}/mode/${id}`, body),

  deleteMode: (id: number) => client.delete(`${entitiesUrl}/mode/${id}`),

  // TUTs
  createTUT: (body: TimeUnderTension) =>
    client.post(`${entitiesUrl}/tut/create`, body),

  updateTUT: (id: number, body: TimeUnderTension) =>
    client.put(`${entitiesUrl}/tut/${id}`, body),

  getTUTs: (params?: URLSearchParams) =>
    client.get<{ list: TimeUnderTension[] }>(`${entitiesUrl}/tut/get`, {
      params,
    }),

  getPaginatedTUTs: (params?: URLSearchParams) =>
    client.get<PagedResults<TimeUnderTension> | { list: TimeUnderTension[] }>(
      `${newEntitiesUrl}/tut/get-paginated`,
      { params }
    ),

  deleteTUT: (id: number) => client.delete(`${entitiesUrl}/tut/${id}`),
  // Recuperi
  createRec: (body: Rec) => client.post(`${entitiesUrl}/rec/create`, body),

  updateRec: (id: number, body: Rec) =>
    client.put(`${entitiesUrl}/rec/${id}`, body),

  getRecs: (params?: URLSearchParams) =>
    client.get<{ list: Rec[] }>(`${entitiesUrl}/rec/get`, { params }),
  getPaginatedRecs: (params?: URLSearchParams) =>
    client.get<PagedResults<Rec> | { list: Rec[] }>(
      `${newEntitiesUrl}/rec/get-paginated`,
      { params }
    ),

  deleteRec: (id: number) => client.delete(`${entitiesUrl}/rec/${id}`),
  //Rep Scheme Type
  createRepSchemeType: (body: RepSchemeType) =>
    client.post(`${entitiesUrl}/rep-scheme-type/create`, body),

  updateRepSchemeType: (id: number, body: RepSchemeType) =>
    client.put(`${entitiesUrl}/rep-scheme-type/${id}`, body),

  getRepSchemeTypes: (params?: URLSearchParams) =>
    client.get<{ list: RepSchemeType[] }>(
      `${entitiesUrl}/rep-scheme-type/get`,
      { params }
    ),

  getPaginatedRepSchemeTypes: (params?: URLSearchParams) =>
    client.get<PagedResults<RepSchemeType> | { list: RepSchemeType[] }>(
      `${newEntitiesUrl}/rep-scheme-type/get-paginated`,
      { params }
    ),

  deleteRepSchemeType: (id: number) =>
    client.delete(`${entitiesUrl}/rep-scheme-type/${id}`),
  //Rep Scheme
  createRepScheme: (body: RepScheme) =>
    client.post(`${entitiesUrl}/rep-scheme/create`, body),

  updateRepScheme: (id: number, body: RepScheme) =>
    client.put(`${entitiesUrl}/rep-scheme/${id}`, body),

  getRepSchemes: (params?: URLSearchParams) =>
    client.get<{ list: RepScheme[] }>(`${entitiesUrl}/rep-scheme/get`, {
      params,
    }),

  getPaginatedRepSchemes: (params?: URLSearchParams) =>
    client.get<PagedResults<RepScheme> | { list: RepScheme[] }>(
      `${newEntitiesUrl}/rep-scheme/get-paginated`,
      { params }
    ),

  deleteRepScheme: (id: number) =>
    client.delete(`${entitiesUrl}/rep-scheme/${id}`),
  //Effort type
  createEffortType: (body: EffortType) =>
    client.post(`${entitiesUrl}/effort-type/create`, body),

  updateEffortType: (id: number, body: EffortType) =>
    client.put(`${entitiesUrl}/effort-type/${id}`, body),

  getEffortTypes: (params?: URLSearchParams) =>
    client.get<{ list: EffortType[] }>(`${entitiesUrl}/effort-type/get`, {
      params,
    }),

  getPaginatedEffortTypes: (params?: URLSearchParams) =>
    client.get<PagedResults<EffortType> | { list: EffortType[] }>(
      `${newEntitiesUrl}/effort-type/get-paginated`,
      { params }
    ),

  deleteEffortType: (id: number) =>
    client.delete(`${entitiesUrl}/effort-type/${id}`),
  //Effort
  createEffort: (body: Effort) =>
    client.post(`${entitiesUrl}/effort/create`, body),

  updateEffort: (id: number, body: Effort) =>
    client.put(`${entitiesUrl}/effort/${id}`, body),

  getEfforts: (params?: URLSearchParams) =>
    client.get<{ list: Effort[] }>(`${entitiesUrl}/effort/get`, {
      params,
    }),

  getPaginatedEfforts: (params?: URLSearchParams) =>
    client.get<PagedResults<Effort> | { list: Effort[] }>(
      `${newEntitiesUrl}/effort/get-paginated`,
      { params }
    ),

  deleteEffort: (id: number) => client.delete(`${entitiesUrl}/effort/${id}`),

  // Progressioni precompilate
  createPrecompiledProgression: (body: Omit<PrecompiledProgression, "id">) =>
    client.post<{ progression: PrecompiledProgression }>(
      `${entitiesUrl}/progression/create`,
      body
    ),

  updatePrecompiledProgression: (id: string, body: Partial<PrecompiledProgression>) =>
    client.put(`${entitiesUrl}/progression/${id}`, body),

  getPrecompiledProgressions: (params?: URLSearchParams) =>
    client.get<{ list: PrecompiledProgression[] }>(`${entitiesUrl}/progression/get`, { params }),

  getPrecompiledProgressionsPaginated: (params?: URLSearchParams) =>
    client.get<PagedResults<PrecompiledProgression>>(`${newEntitiesUrl}/progression/get-paginated`, { params }),

  getPrecompiledProgression: (id: string) =>
    client.get<{ progression: PrecompiledProgression }>(`${entitiesUrl}/progression/single/${id}`),

  deletePrecompiledProgression: (id: string) =>
    client.delete(`${entitiesUrl}/progression/${id}`),

  // RepSchemes filtrati per tipo
  getRepSchemesByType: (repSchemeTypeId: number) => {
    const params = new URLSearchParams();
    params.append("repSchemeTypeId", `${repSchemeTypeId}`);
    params.append("size", "200");
    return client.get<PagedResults<RepScheme>>(`${newEntitiesUrl}/rep-scheme/get-paginated`, { params });
  },

  // Efforts filtrati per tipo
  getEffortsByType: (effortTypeId: number) => {
    const params = new URLSearchParams();
    params.append("effortTypeId", `${effortTypeId}`);
    params.append("size", "200");
    return client.get<PagedResults<Effort>>(`${newEntitiesUrl}/effort/get-paginated`, { params });
  },
};
